import cardiologiaIcon from '../assets/images/cadiologiaicone.png';
import endocrinologiaIcon from '../assets/images/thyroid_4349209.png';
import endocrinologiaPediatricaIcon from '../assets/images/thyroid_6147774.png';
import pediatriaIcon from '../assets/images/pediatric_12024586.png';
import nutricaoIcon from '../assets/images/nutrition_1786614.png';

export const especialidadesData = [
  {
    title: 'MEDICINA FUNCIONAL INTEGRATIVA',
    description: 'Cuidado especializado para sua saúde integral.',
    color: 'light',
    icon: cardiologiaIcon
  },
  {
    title: 'ENDOCRINOLOGIA',
    description: 'Cuidado especializado para o seu sistema hormonal.',
    color: 'dark',
    icon: endocrinologiaIcon
  },
  {
    title: 'ENDOCRINOLOGIA PEDIÁTRICA',
    description: 'Cuidado especializado com o sistema hormonal das crianças.',
    color: 'light',
    icon: endocrinologiaPediatricaIcon
  },
  {
    title: 'PEDIATRIA FUNCIONAL INTEGRATIVA',
    description: 'Cuidado integral para o crescimento saudável das crianças.',
    color: 'dark',
    icon: pediatriaIcon
  },
  {
    title: 'NUTRIÇÃO',
    description: 'Alimentação saudável e equilibrada para seu bem-estar.',
    color: 'light',
    icon: nutricaoIcon
  }
];

export const WHATSAPP_URL = 'https://wa.me/5524988345771?text=Ol%C3%A1%2C%20venho%20do%20site%20e%20gostaria%20de%20agendar%20uma%20consulta!';
